import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, useContext, useState } from 'react';
import type { ChatResourceEvent } from '../../hooks/use-chat-ws';

// When set, the global chat widget runs in investigation-scoped mode: a normal default chat
// that references the investigation as resource context, layering in the artifact-saved
// features. Null → the generic Percy chat.
//
// The investigation page owns the blocks data (useBlocks) and sets this; the
// widget only consumes the chat-relevant slice, so it never imports gen-ui internals.
export type InvestigationChatScope = {
  fpId: string;
  investigationId: string;
  // Refresh the left panel when the agent saves an artifact or emits a ui block.
  onResourceEvent?: (event: ChatResourceEvent) => void;
};
type InvestigationScopeContextValue = {
  scope: InvestigationChatScope | null;
  setScope: (scope: InvestigationChatScope | null) => void;
};
const InvestigationScopeContext = createContext<InvestigationScopeContextValue | null>(null);
export const InvestigationScopeProvider = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const [scope, setScope] = useState(null);
  let t1;
  if ($[0] !== scope) {
    t1 = {
      scope,
      setScope
    };
    $[0] = scope;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const value = t1;
  let t2;
  if ($[2] !== children || $[3] !== value) {
    t2 = <InvestigationScopeContext.Provider value={value}>{children}</InvestigationScopeContext.Provider>;
    $[2] = children;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export const useInvestigationScope = () => {
  return useContext(InvestigationScopeContext)?.scope ?? null;
};

/** For the investigation page to publish / clear its scope. Safe no-op outside a provider. */
export const useSetInvestigationScope = () => {
  return useContext(InvestigationScopeContext)?.setScope ?? _temp;
};
function _temp() {}